import type { NodeDefinition } from '../../../types/node-definition';

/**
 * Chat Memory Manager Node Definition
 * 
 * Manages chat message history for AI conversations. Provides operations to:
 * - Retrieve messages from a session
 * - Insert new messages
 * - Delete messages
 * - Clear entire session history
 * 
 * Works with the ChatService to persist and retrieve conversation history.
 */
const definition: NodeDefinition = {
  type: 'chat-memory-manager',
  name: 'Chat Memory Manager',
  description: 'Manage chat message history - retrieve, insert, delete, or clear messages',
  version: '1.0.0',
  
  category: 'ai-nodes',
  icon: 'MessageSquare',
  color: 'green', // Emerald green
  
  group: ['ai'],
  
  defaults: {
    name: 'Chat Memory Manager',
    color: 'green'
  },
  
  subtitle: 'Manage conversation history',
  
  // Flag to use same styling as AI Agent (wide rectangular with label inside)
  displayStyle: 'wide-rectangular',
  
  inputs: [
    {
      name: 'main',
      type: 'main',
      displayName: 'Input',
      required: true
    }
  ],
  
  outputs: [
    {
      name: 'main',
      type: 'main',
      displayName: 'Output'
    }
  ],
  
  anchors: {
    output: [
      {
        type: 'subNode',
        subNodeCategory: 'memory',
        label: 'Memory',
        required: true,
        description: 'Connect a memory sub-node to manage chat history',
        position: 'bottom'
      }
    ]
  },
  
  credentials: [],
  
  tags: ['chat', 'memory', 'history', 'conversation', 'messages'],
  
  metadata: {
    author: 'Evo E2E Team',
    documentation: 'https://docs.evoe2e.com/nodes/chat-memory-manager'
  },
  
  comingSoon: false
};

export default definition;
